import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import challengeService from "../services/challengeService";

const initialState = {
  challenge: {},
  error: false,
  success: false,
  loading: false,
  message: null,  
}

export const addChallenge = createAsyncThunk(
  "challenge/add",
  async (challenge, thunkAPI) => {
    const data = await challengeService.addChallenge(challenge);

    // Check for errors
    if (data.errors) {
      return thunkAPI.rejectWithValue(data.errors[0]);
    }

    return data;
  }
);

export const listChallenge = createAsyncThunk(
  "challenge/list",
  async (challenge, thunkAPI) => {
    const data = await challengeService.listChallenge(challenge);

    return data;
  }
);

export const updateChallenge = createAsyncThunk(
  "challenge/update",
  async (challenge, thunkAPI) => {
    try {
      // Envia a requisição com credenciais (cookies HttpOnly) automaticamente
      const data = await challengeService.updateChallenge(challenge, { withCredentials: true });

      // Verifica se há erros
      if (data.errors) {
        return thunkAPI.rejectWithValue(data.errors[0]);
      }

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Erro ao atualizar o perfil.");
    }
  }
);

export const getChallengeById = createAsyncThunk(
  "challenge/get",
  async (id, thunkAPI) => {

    const data = await challengeService.getChallengeById(id);

    return data;
  }
);

export const getChallengeByIdNoAnswer = createAsyncThunk(
  "challenge/getna",
  async (id, thunkAPI) => {

    const data = await challengeService.getChallengeByIdNoAnswer(id);

    return data;
  }
);


export const getChallengeByPhaseBlock = createAsyncThunk(
  'data/getPhaseBlock',
  async ({ phase, block }, { rejectWithValue }) => {
    try {
      const data = await challengeService.getChallengeByPhaseBlock(phase, block);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteChallengeById = createAsyncThunk(
  "challenge/delete",
  async (id, thunkAPI) => {

    const data = await challengeService.deleteChallengeById(id);

    return data;
  }
);

export const challengeSlice = createSlice({
  name: "challenge",
  initialState,
  reducers: {
    resetMessage: (state) => {
      state.message = null;
    }
  },
  extraReducers: (builder) =>{
    builder
      .addCase(addChallenge.pending, (state) => {
        state.profile = true;
        state.error = null;
      })
      .addCase(addChallenge.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.challenge = action.payload;
      })
      .addCase(updateChallenge.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.message = null;
        state.success = false;
      })
      .addCase(updateChallenge.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.challenge = action.payload;
        state.message = "Desafio atualizado com sucesso!"
      })
      .addCase(updateChallenge.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.challenge = null;
        state.success = "Erro na atualização!";
        state.message = false;
      })
      .addCase(listChallenge.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(listChallenge.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.challenge = action.payload;
        state.message = null;
      })
      .addCase(getChallengeById.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getChallengeById.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.challenge = action.payload;
        state.message = "Challenge encontrado com sucesso!"
      })
      .addCase(getChallengeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.challenge = null;
      })
      .addCase(deleteChallengeById.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(deleteChallengeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.challenge = null;
      })
      .addCase(deleteChallengeById.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.challenge = action.payload;
        state.message = "Challenge excluído com sucesso!"
      })
      .addCase(getChallengeByPhaseBlock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChallengeByPhaseBlock.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getChallengeByPhaseBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getChallengeByIdNoAnswer.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getChallengeByIdNoAnswer.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.challenge = action.payload;
        state.message = "Challenge encontrado com sucesso!"
      })
      .addCase(getChallengeByIdNoAnswer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.challenge = null;
      })
  }
});

export const {resetMessage} = challengeSlice.actions;
export default challengeSlice.reducer;